// Product types
export const PRODUCT_ALLOCATED_PENSION_CASH = 'AllocatedPensionCash';
export const PRODUCT_ALLOCATED_PENSION_FIXED = 'AllocatedPensionFixed';
export const PRODUCT_ANNUITY_FIXED_TERM = 'AnnuityFixedTerm';
export const PRODUCT_ANNUITY_LIQUID_LIFETIME = 'AnnuityLiquidLifetime';
export const PRODUCT_ANNUITY_LIFETIME = 'AnnuityLifetime';
export const PRODUCT_CARE_PLUS = 'CarePlus';
export const PRODUCT_SUPERANNUATION_FUND_CASH = 'SuperannuationFundCash';
export const PRODUCT_SUPERANNUATION_FUND_FIXED = 'SuperannuationFundFixed';
export const PRODUCT_TERM_ALLOCATED_PENSION_CASH = 'TermAllocatedPensionCash';
export const PRODUCT_TERM_ALLOCATED_PENSION_FIXED = 'TermAllocatedPensionFixed';
export const PRODUCT_UNIT_TRUST = 'UnitTrust';

// Table Labels
export const ACCOUNT_NAME = { label: 'Account name', key: 'accountName' };
export const ACCOUNT_NUMBER = { label: 'Account number', key: 'accountNo' };
export const ACCOUNT_TYPE = { label: 'Account type', key: 'accountType' };
export const ATE = { label: 'Asset Test Exempt', key: 'ate' };
export const BALANCE = { label: 'Balance', key: 'balanceAmount' };
export const BALANCE_CLOSED = { label: 'Balance', key: 'balanceAmountClosed' };
export const CAN_YOU_WITHDRAW = { label: 'Can you withdraw?', key: 'isCommutable' };
export const DATE = { label: 'Date', key: 'unitPriceDate' };
export const DATE_CLOSED = { label: 'Date closed', key: 'closedDate' };
export const FIXED_RATE = { label: 'Fixed rate', key: 'fixedRate' };
export const INDEXATION = { label: 'Indexation', key: 'indexationDisplayText' };
export const INVESTMENT_AMOUNT = { label: 'Investment amount', key: 'purchasePrice' };
export const INVESTMENT_STATUS = { label: 'Investment status', key: 'investmentStatus' };
export const INVESTMENT_STATUS_CLOSED = {
  label: 'Investment status',
  key: 'investmentStatus',
};
export const INVESTMENT_CLOSED = { label: 'Investment status', key: 'closedDate' };
export const JOINT_INVESTORS = { label: 'Joint investors', key: '' };
export const MATURITY_DATE = { label: 'Maturity date', key: 'maturityDate' };
export const MATURITY_VALUE = { label: 'Maturity value', key: 'maturityValue' };
export const NEXT_PAYMENT = { label: 'Next payment', key: 'nextPaymentAmount' };
export const NEXT_PAYMENT_CLOSED = { label: 'Next payment', key: 'nextPaymentClosed' };
export const NEXT_PAYMENT_DATE = { label: 'Next payment date', key: 'nextPaymentDate' };
export const OPENED = { label: 'Opened', key: 'openDate' };
export const PAY_FREQUENCY = { label: 'Pay frequency', key: 'paymentFrequency' };
export const PAYMENT_AMOUNT = { label: 'Payment amount', key: 'nextPaymentAmount' };
export const PAYMENT_DATE = { label: 'Payment date', key: 'nextPaymentDate' };
export const PAYMENT_OPTION = { label: 'Payment option', key: 'indexationDisplayText' };
export const INVESTMENT_OPTION_START_DATE = { label: 'Investment option start date', key: 'openDate' };
export const POLICY_NAME = { label: 'Policy name', key: 'accountName' };
export const POLICY_NUMBER = { label: 'Policy number', key: 'accountNo' };
export const POLICY_TYPE = { label: 'Policy type', key: 'accountType' };
export const PURCHASE_PRICE = { label: 'Purchase price', key: 'purchasePrice' };
export const RCV = { label: 'Residual Capital Value', key: 'rcv' };
export const TAX_STATUS = { label: 'Tax status', key: 'taxStatus' };
export const TFN_PROVIDED = { label: 'TFN provided', key: 'tfnProvided' };
export const TERM = { label: 'Term', key: 'term' };
export const TTR = { label: 'TTR', key: 'isTransitionToRetirement' };
export const UNIT_PRICE = { label: 'Unit price', key: 'unitPrice' };
export const UNIT_PRICE_CLOSED = { label: 'Unit price', key: 'unitPriceClosed' };
export const UNITS = { label: 'Units', key: 'numberOfUnits' };
export const UNITS_CLOSED = { label: 'Units', key: 'numberOfUnitsClosed' };
export const WITHDRAWAL_GUARANTEE = { label: 'Withdrawal guarantee', key: 'withdrawalGuarantee' };
export const WITHDRAWAL_PERIOD_ENDS = {
  label: 'Withdrawal period ends',
  key: 'withdrawalPeriodEnds',
};
export const UPFRONT_ASF_WITH_GST = { label: 'Upfront ASF $ (Incl any GST)', key: 'upfrontASFWithGST'};
export const REGULAR_ASF_PER_PAYMENT_AMT = { label: 'Regular ASF $ (Incl any GST)', key: 'regularASFPerPaymentAmt'};
export const REGULAR_ASF_TYPE = { label: 'Regular ASF Type', key: 'regularASFType'};
export const REGULAR_ASF_CONSENT_EXPIRY_DATE = { label: 'Fee consent expiry date', key: 'regularASFConsentExpiryDate'};


// Keys in api response
export const KEY_ACCOUNT_NAME = 'accountName';
export const KEY_ACCOUNT_NUMBER = 'accountNo';
export const KEY_BALANCE_AMOUNT = 'balanceAmount';
export const KEY_NEXT_PAYMENT_AMOUNT = 'nextPaymentAmount';
export const KEY_NEXT_PAYMENT_DATE = 'nextPaymentDate';
export const KEY_MATURITY_DATE = 'maturityDate';
export const KEY_TERM = 'term';
export const KEY_UNIT_PRICE = 'unitPrice';
export const KEY_UNITS = 'units';
